const SHOWCASE_ES = {
  title: 'Showcase',
  subtitle:
    'Esta página te permite comparar los candidatos en base a los requerimientos más importantes',
  mobileView:
    'Hemos optimizado esta experiencia en <1>Desktop</1> para que los datos y las evaluaciones de los candidatos sean más útiles',
  lastViewUpdate:
    'Datos guardados el {{ date, datetime(format: dd/MM/yyyy) }} a las {{ date, datetime(format: HH:mm) }}',
  yes: 'Sí',
  no: 'No',
  bubbleText:
    'Esta página compara las características de los perfiles que se le presentan. Una herramienta para ayudarte a elegir a las personas adecuadas.',
  emptyCandidateList:
    'Desde aquí, podrás <strong>comparar</strong> las principales características de los <strong>candidatos</strong> que te hemos presentado.',
  tableRows: {
    photo: 'Foto',
    age: 'Edad',
    seniority: 'Seniority',
    location: 'Domicilio',
    must_have: 'Must have',
    nice_to_have: 'Nice to have',
    current_global_compensation: 'Paquete de compensación actual',
    desired_global_compensation: 'Paquete de compensación deseado',
    non_compete_agreement: 'Acuerdos de no competencia',
    notice_period: 'Período de preaviso',
    company: 'Empresa',
    other_selections: 'Otros<1></1>procesos<1></1>de selección',
    motivation: 'Motivación',
    summary: 'Resumen',
  },
  filters: {
    restoreView: 'Restaurar',
    interestedBut: 'Muestra <1>Interesados pero</1>',
    out: 'Muestra <1>Candidatos descartados</1>',
  },
  benefitsCategories: {
    car: 'Coche de empresa',
    food: 'Vales de comida o comedor',
    training: 'Capacitación',
    welfare: 'Beneficios sociales',
    insurance: 'Seguro',
    devices: 'Dispositivos',
    remote_working: 'Trabajo remoto o horarios flexibles',
  },
  company: {
    freelance: 'Autónomo / Freelancer',
  },
  concernsCategories: {
    brand: 'Marca',
    role: 'Rol',
    compensation: 'Salario',
    location: 'Localización',
  },
  location: {
    locationAndDistance: '<strong>{{ location }}</strong>',
    locationAndDistance_withDistance:
      '<strong>{{ location }}</strong> ({{ distance }}km)',
  },
  summary: {
    readmore: 'Leer más',
    hide: 'Esconder',
  },
  chip: {
    interestedBut: 'Interesados pero',
    out: 'Candidatos descartados',
  },
  motivationToChangeValues: {
    low: 'Bajo',
    high: 'Alto',
    medium: 'Medio',
  },
  drivingTime: {
    hours: '<b>{{ hours }}</b> h',
    minutes: '<b>{{ minutes }}</b> min',
  },
  otherSelections: {
    inProgress: '{{ count }} en proceso',
    notSpecified: 'Otros en proceso, no especificados',
  },
  currentGlobalCompensation: {
    payTransparencyDisclaimer:
      'Solicitar información sobre la remuneración actual o pasada está legalmente restringido a partir del 7 de julio de 2026 (Directiva (UE) 2023/970).<br/><br/>Concéntrese en cambio en las expectativas salariales.',
  },
};

export default SHOWCASE_ES;
